import RequestDetailsTable, { RequestDetailsTableProps } from './RequestDetailsTable';

export type { RequestDetailsTableProps };
export default RequestDetailsTable;
